import React from 'react';
import { View, Text, StyleSheet, Image, Switch, TouchableOpacity, TouchableHighlight, Platform, Alert, Dimensions } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { addressToolTip } from '../../constants/Arrays';
import { TextInputContainer, Button, BackgroundGradient, Validate, AddressPicker, Loader, ToolTipWrapper } from '../../components';
import { FontAwesome, FontAwesome5 } from '@expo/vector-icons';
import { useHeaderHeight } from '@react-navigation/elements';
import Constants from 'expo-constants';
import { Camera, CameraType } from 'expo-camera';
import { formatPhoneNumber } from '../../utils/Functions';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useLinkTo } from '@react-navigation/native';
import Images from '../../constants/Images';

const PersonalProfile = ({ ...props }) => {
  // const [addressSuggestions, setAddressSuggestions] = React.useState([]);
  // const [addressLoading, setAddressLoading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showAddressSuggestionOverlay, setShowAddressSuggestionOverlay] = React.useState(false);
  const [cameraPreview, setCameraPreview] = React.useState(false);
  const [cameraType, setCameraType] = React.useState(CameraType.front);

  const headerHeight = useHeaderHeight();
  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();
  const screenWidth = Platform.OS === 'web' ? 768 : Dimensions.get('window').width;
  const middleScreen = screenWidth / 2 - 10;

  const defaultIsInvalid = { emailAddress: false, firstName: false, lastName: false, mobileNumber: false, houseNumber: false, houseAddress: false };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  let textInputs = {
    emailAddress: React.useRef(null),
    firstName: React.useRef(null),
    lastName: React.useRef(null),
    mobileNumber: React.useRef(null),
    houseNumber: React.useRef(null),
    houseAddress: React.useRef(null),
  };

  let avatarPhotoRef = null;

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.AccountType && !props.signUpProgress.CompanyProfile) {
      linkTo('/login');
    }
  }

  const checkPersonalProfile = async () => {
    // emailAddress
    if (props.accountType !== 'Email' && !Validate.Email(props.emailAddress)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
      textInputs.emailAddress.current.focus();
      return;
    }
    // firstName
    props.setFirstName(props.firstName.trim());
    if (!Validate.Name(props.firstName)) {
      setIsInvalid(prevState => { return { ...prevState, firstName: true } });
      textInputs.firstName.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, firstName: false } });
    // lastName
    props.setLastName(props.lastName.trim());
    if (!Validate.Name(props.lastName)) {
      setIsInvalid(prevState => { return { ...prevState, lastName: true } });
      textInputs.lastName.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, lastName: false } });
    // mobileNumber
    if(props.hasMobile){
      if (!Validate.PhoneNumber(props.mobileNumber)) {
        setIsInvalid(prevState => { return { ...prevState, mobileNumber: true } });
        textInputs.mobileNumber.current.focus();
        return;
      }
      setIsInvalid(prevState => { return { ...prevState, mobileNumber: false } });
    }else{
      // houseNumber
      if (!Validate.PhoneNumber(props.houseNumber)) {
        setIsInvalid(prevState => { return { ...prevState, houseNumber: true } });
        textInputs.houseNumber.current.focus();
        return;
      }
      setIsInvalid(prevState => { return { ...prevState, houseNumber: false } });
    }
    
    if (!props.streetId) {
      setIsInvalid(prevState => { return { ...prevState, houseAddress: true } });
      textInputs.houseAddress.current.focus();
      return;
    }
    if (props.accountType !== 'Email'){
      setLoading(true);
      let existingResult = await Validate.isExistingEmail(props.emailAddress);
      setLoading(false);
      if (existingResult.result) {
        if (existingResult.isExisting) {
          setTimeout(() => {
            Alert.alert(
              'Existing Email Address',
              'This email address has already been used to create an account.',
              [
                {
                  text: 'Login with this email address',
                  onPress: () => navigation.navigate('Login', { emailAddress: props.emailAddress })
                },
                {
                  text: 'Edit email address',
                  onPress: () => editEmailAddress()
                }
              ],
              { cancelable: false }
            );
          }, 1000);
          return;
        }
      } else {
        return;
      }
    }
    props.completeStep('PersonalProfile');
  };
  const editEmailAddress = () => {
    props.setEmailAddress(null);
    // textInputs.emailAddress.current.focus();
  }

  const onChangeEmailAddress = (emailAddress) => {
    if (isInvalid.emailAddress && Validate.Email(emailAddress)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    }
    props.setEmailAddress(emailAddress.trim());
    props.setContractorEmailAddress(emailAddress.trim());
  };
  const onChangeFirstName = (firstName) => {
    if (isInvalid.firstName && Validate.Name(firstName)) {
      setIsInvalid(prevState => { return { ...prevState, firstName: false } });
    }
    props.setFirstName(firstName);
  };
  const onChangeLastName = (lastName) => {
    if (isInvalid.lastName && Validate.Name(lastName)) {
      setIsInvalid(prevState => { return { ...prevState, lastName: false } });
    }
    props.setLastName(lastName);
  };
  const onChangeMobileNumber = (mobileNumber) => {
    mobileNumber = formatPhoneNumber(mobileNumber);
    if (isInvalid.mobileNumber && Validate.PhoneNumber(mobileNumber)) {
      setIsInvalid(prevState => { return { ...prevState, mobileNumber: false } });
    }
    props.setMobileNumber(mobileNumber.trim());
    // props.setContractorPhoneNumber(mobileNumber.trim());
  };
  const onChangeHouseNumber = (houseNumber) => {
    houseNumber = formatPhoneNumber(houseNumber);
    if (isInvalid.houseNumber && Validate.PhoneNumber(houseNumber)) {
      setIsInvalid(prevState => { return { ...prevState, houseNumber: false } });
    }
    props.setHouseNumber(houseNumber.trim());
  };
  const isInvalidLocation = () => {
    setIsInvalid(prevState => { return { ...prevState, houseAddess: false } });
  }

  const previewAvatarPhoto = async () => {
    const permissionResult = await Camera.requestCameraPermissionsAsync();
    if (!permissionResult.granted) {
      Alert.alert("Permission to access camera is required!");
      return;
    }
    setCameraPreview(true);
  }
  const takeAvatarPhoto = async () => {
    console.log('take photo id');
    if (avatarPhotoRef) {
      let result = await avatarPhotoRef.takePictureAsync({
        quality: Images.quality,
        base64: false,
        exif: false,
      });
      if (!result.cancelled) {
        props.setAvatar(result);
        cancelCameraPreview();
      }
    }
  }
  const cancelCameraPreview = () => {
    setCameraPreview(false);
  }
  const reverseCamera = () => {
    setCameraType(
      cameraType === CameraType.back
        ? CameraType.front
        : CameraType.back
    );
  }

  const changeMobileHomeNumber = (v) => {
    props.setMobileNumber('');
    props.setHouseNumber('');
    props.setHasMobile(v);
  }

  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack();
    } else {
      linkTo('/signup/accounttype');
    }
  }

  const photoIconContainerStyle = () => {
    let style = {
      position: 'absolute',
      bottom: 12,
      left: middleScreen - 90,
      padding: 16,
      borderRadius: 100,
      backgroundColor: Colors.lightBlue,
      height: 66,
      width: 66,
      alignItems: 'center',
      justifyContent: 'center'
    };
    if (Platform.OS === 'web') {
      style.bottom = 0;
      style.left = middleScreen - 23;
    }
    return style;
  }
  const cameraIconContainerStyle = () => {
    return {
      position: 'absolute',
      bottom: 12,
      left: middleScreen + 24,
      padding: 16,
      borderRadius: 100,
      backgroundColor: Colors.lightBlue,
      height: 66,
      width: 66,
      alignItems: 'center',
      justifyContent: 'center'
    };
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <KeyboardAwareScrollView style={styles.profile} keyboardShouldPersistTaps='handled' contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Personal Profile</Text>
        </TouchableOpacity>
        {/* <Text style={[CS.mediumTitle, CS.lightText]}>Personal Profile</Text> */}
        <View style={styles.avatarPickerContainer}>
          {cameraPreview && 
          <>
            <View style={styles.avatarContainer}>
              <Camera style={styles.avatar} type={cameraType} ref={ref => avatarPhotoRef = ref}></Camera>
            </View>
            <TouchableOpacity style={[styles.previewIconContainer, styles.previewCancel]} onPress={() => cancelCameraPreview()} underlayColor={Colors.red}>
              <FontAwesome name="remove" size={32} color="white" />
            </TouchableOpacity>
            <TouchableOpacity style={[styles.previewIconContainer, styles.previewReverse]} onPress={() => reverseCamera()} activeOpacity={0.6}>
              <FontAwesome name="refresh" size={32} color='white' />
            </TouchableOpacity>
            <TouchableOpacity style={[styles.previewIconContainer, styles.previewTake]} onPress={() => takeAvatarPhoto()} underlayColor={Colors.yellow}>
              <FontAwesome name="check" size={32} color="white" />
            </TouchableOpacity>
          </>
          }
          {!cameraPreview && props.avatar &&
            <View style={styles.avatarContainer}>
              <Image source={{ uri: props.avatar.uri }} style={styles.avatar} />
            </View>
          }
          {!cameraPreview && !props.avatar &&
            <FontAwesome name="user-circle-o" size={186} color={Colors.lightGrey} style={styles.avatarBlank} />
          }
          {!cameraPreview &&
            <>
              <TouchableHighlight style={photoIconContainerStyle()} onPress={props.chooseAvatarPhoto} underlayColor={Colors.yellow}>
                <FontAwesome name="photo" size={32} color="white" />
              </TouchableHighlight>
              {Platform.OS !== 'web'
              ?
              <TouchableHighlight style={cameraIconContainerStyle()} onPress={() => previewAvatarPhoto()} underlayColor={Colors.yellow}>
                <FontAwesome name="camera" size={32} color="white" />
              </TouchableHighlight>
              : null
              }
            </>
          }
        </View>
        {props.accountType !== 'Email' && 
          <>
            <View style={[CS.rowContainer, styles.inputLabel]}>
              <Text style={[CS.smallText, CS.lightBlueText]}>Email Address</Text>
            </View>
            <TextInputContainer
              iconName='envelope'
              placeholder='Email Address'
              textContentType='username'
              onChangeText={(t) => onChangeEmailAddress(t)}
              inputRef={textInputs.emailAddress}
              keyboardType='email-address'
              // autoFocus={true} 
              isInvalid={isInvalid.emailAddress}
              value={props.emailAddress}
              autoCapitalize='none'
              autoCompleteType='username'
              autoCorrect={false}
              clear-button-mode='while-editing'
              returnKeyType='next'
              enablesReturnKeyAutomatically={true}
              onSubmitEditing={() => textInputs.firstName.current.focus()}
            />
          </>
        }
        <View style={[CS.rowContainer, styles.inputLabel]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>First Name</Text>
        </View>
        <TextInputContainer 
          iconName='user'
          placeholder='First Name'
          textContentType='givenName'
          onChangeText={(t) => onChangeFirstName(t)}
          value={props.firstName}
          inputRef={textInputs.firstName}
          isInvalid={isInvalid.firstName}
          autoCompleteType={Platform.OS === 'web' ? 'given-name' : 'name'}
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => textInputs.lastName.current.focus()}
        />
        <View style={[CS.rowContainer, styles.inputLabel]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Last Name</Text>
        </View>
        <TextInputContainer
          iconName='user'
          placeholder='Last Name'
          textContentType='familyName'
          onChangeText={(t) => onChangeLastName(t)}
          value={props.lastName}
          inputRef={textInputs.lastName}
          isInvalid={isInvalid.lastName}
          autoCompleteType={Platform.OS === 'web' ? 'family-name' : 'name'}
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => { props.hasMobile ? textInputs.mobileNumber.current.focus() : textInputs.homeNumber.current.focus()}}
        />
        <View style={[CS.rowContainer, styles.switchContainer]}>
          <Switch style={styles.switch} value={props.hasMobile} onValueChange={changeMobileHomeNumber} trackColor={{ true: Colors.yellow, false: Colors.lightBlue }} ios_backgroundColor={Colors.lightBlue} thumbColor={props.hasMobile ? Colors.white : Colors.lightGrey} />
          <Text style={[CS.smallText, CS.lightText]}>{props.hasMobile ? 'I have a mobile number' : 'I do not have a mobile number'}</Text>
        </View>
        <View style={[CS.rowContainer, styles.inputLabel]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>{props.hasMobile ? 'Mobile' : 'Home'} Phone Number</Text>
        </View>
        {props.hasMobile && 
        <TextInputContainer
          iconName='phone'
          placeholder='Mobile Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangeMobileNumber(t)}
          value={props.mobileNumber}
          inputRef={textInputs.mobileNumber}
          isInvalid={isInvalid.mobileNumber}
          returnKeyType='done'
          onSubmitEditing={() => textInputs.houseAddress.current.focus()}
        />
        }
        {!props.hasMobile && 
        <TextInputContainer
          iconName='phone'
          placeholder='Home Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangeHouseNumber(t)}
          value={props.houseNumber}
          inputRef={textInputs.houseNumber}
          isInvalid={isInvalid.houseNumber}
          returnKeyType='done'
          onSubmitEditing={() => textInputs.houseAddress.current.focus()}
        />
        }
        <View style={[CS.rowContainer, styles.inputLabel]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Address</Text>
          <ToolTipWrapper
            text={addressToolTip}
          />
        </View>
        <AddressPicker
          iconName='home'
          placeholder='Home Address'
          innerPlaceholder='10-1000 Main St. Toronto, ON'
          value={props.address}
          offsetTop={Constants.statusBarHeight}
          setAddress={props.setAddress}
          setStreetId={props.setStreetId}
          setZipCode={props.setZipCode}
          setStreetNumber={props.setStreetNumber}
          setAddressUnit={props.setAddressUnit}
          setCountry={props.setCountry}
          setLongitude={props.setLongitude}
          setLatitude={props.setLatitude}
          inputRef={textInputs.houseAddress}
          setIsInvalid={isInvalidLocation}
        />
        {props.isContractor &&
          <Text style={[CS.miniText, CS.lightBlueText, CS.italicText, { top: -18, position: 'relative' }]}>* When acting as a contractor, your personal address will never be shown</Text>
        }
        <Button text='Continue' onPress={() => checkPersonalProfile} />
      </KeyboardAwareScrollView>
    </View>
  );

}

const styles = StyleSheet.create({
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: 'center',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center'
  },
  profile: {
    width: '100%',
    marginVertical: 10,
  },
  switchContainer: {
    marginBottom: 20,
  },
  switch: {
    marginRight: 10,
  },
  avatarPickerContainer: {
    alignItems: 'center',
    position: 'relative',
    padding: 20,
    marginBottom: 20,
    // backgroundColor: 'pink',
  },
  avatarContainer: {
    borderRadius: 100,
    overflow: 'hidden',
    borderStyle: 'solid',
    borderWidth: 3,
    borderColor: Colors.lightGrey,
  },
  avatar: {
    width: 180,
    height: 180,
  },
  photoIconContainer: {
    position: 'absolute',
    // top: '80%',
    bottom: -10,
    left: -10,
    padding: 16,
    borderRadius: 100,
    backgroundColor: Colors.lightBlue,
    height: 66,
    width: 66,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cameraIconContainer: {
    position: 'absolute',
    // top: '80%',
    bottom: -10,
    right: -10,
    padding: 16,
    borderRadius: 100,
    backgroundColor: Colors.lightBlue,
    height: 66,
    width: 66,
    alignItems: 'center',
    justifyContent: 'center',
  },
  previewIconContainer: {
    position: 'absolute',
    padding: 12,
    borderRadius: 100,
    backgroundColor: Colors.lightBlue,
    height: 56,
    width: 56,
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewCancel: {
    top: '80%',
    right: '70%',
  },
  previewReverse: {
    top: '90%',
    left: '47.5%',
  },
  previewTake: {
    top: '80%',
    left: '70%',
  },
  contractorText: {
    textAlign: 'right',
    flex: 1,
    marginRight: 10,
  },
  addressContainer: {
    position:'absolute',
    top:0,
    left:0,
    width: '100%',
    height: '100%',
    padding: 10,
    borderRadius: 10,
    zIndex: 2,
  },
  suggestionsCloseButton: {
    marginBottom: 10,
  },
  addressSuggestions: {
    position:'absolute',
    top:100,
    left: 10,
    width:'100%',
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 10,
    // paddingBottom: 10,
    backgroundColor: Colors.textInputBackground,
  },
  addressSuggestion: {
    padding:10,
    borderColor: Colors.lightBlue,
  },
  addressSuggestionBorder: {
    borderBottomWidth: 1,
  },
  addressSuggestionNoBorder: {
    borderBottomWidth: 0,
  },
  inputLabel: {
    marginBottom: 5,
  },
});

export default React.memo(PersonalProfile);